import React, { Component } from "react";
import stakeImg from "../../imgs/stake.png";
import stakeBg from "../../imgs/stake-bg.png";
export default class Stake extends Component {
  render() {
    return (
      <div>
        <div className="col-12 d-flex flex-column align-items-center">
          <h6 className="text-lg text-dark text-bold text-center mb-5">
            Stake your panda
          </h6>
          <button
            type="button"
            className="btn btn-lg btn-secondary btn-toggle"
            data-toggle="button"
            aria-pressed="false"
            autoComplete="off"
          >
            <div className="handle" />
          </button>
        </div>
        <div className="stake-container d-flex flex-row align-items-start mt-5">
          <div className="staked-item d-flex flex-column align-items-center">
            <div
              style={{
                backgroundImage: `url(${stakeBg})`,
              }}
              className="staked-img-container"
            >
              <img src={stakeImg} />
            </div>
            <h6 className="text-md text-light text-dark my-2">
              Panda #1 (1.5x)
            </h6>
            <a className="black-btn text-md regular mb-2 stake-btn">Unstake</a>
            <a className="black-btn text-md regular stake-btn">Claim</a>
          </div>

          <div className="staked-item d-flex flex-column align-items-center">
            <div
              style={{
                backgroundImage: `url(${stakeBg})`,
              }}
              className="staked-img-container"
            >
              <img src={stakeImg} />
            </div>
            <h6 className="text-md text-light text-dark my-2">
              Panda #1 (1.5x)
            </h6>
            <a className="black-btn text-md regular mb-2 stake-btn">Unstake</a>
            <a className="black-btn text-md regular stake-btn">Claim</a>
          </div>

          <div className="staked-item d-flex flex-column align-items-center">
            <div
              style={{
                backgroundImage: `url(${stakeBg})`,
              }}
              className="staked-img-container"
            >
              <img src={stakeImg} />
            </div>
            <h6 className="text-md text-light text-dark my-2">
              Panda #1 (1.5x)
            </h6>
            <a className="black-btn text-md regular mb-2 stake-btn">Unstake</a>
            <a className="black-btn text-md regular stake-btn">Claim</a>
          </div>

          <div className="staked-item d-flex flex-column align-items-center">
            <div
              style={{
                backgroundImage: `url(${stakeBg})`,
              }}
              className="staked-img-container"
            >
              <img src={stakeImg} />
            </div>
            <h6 className="text-md text-light text-dark my-2">
              Panda #1 (1.5x)
            </h6>
            <a className="black-btn text-md regular mb-2 stake-btn">Unstake</a>
            <a className="black-btn text-md regular stake-btn">Claim</a>
          </div>
        </div>
      </div>
    );
  }
}
